module.exports = __webpack_public_path__ + "img/DSC_0081.216a2a67.jpg";